import React from 'react';

const money = (value) => `Rp ${Number(value || 0).toLocaleString('id-ID')}`;

const PriceSummaryBlock = ({ totalBasePrice = 0, totalFinalPrice = 0 }) => {
  const totalDiscountAmount = Math.max(totalBasePrice - totalFinalPrice, 0);
  const discountPercent = totalBasePrice > 0 ? (totalDiscountAmount / totalBasePrice) * 100 : 0;
  const hasPriceIssue = totalFinalPrice < 0 || totalBasePrice < 0 || totalFinalPrice > totalBasePrice * 3;
  const isMissingPrice = totalBasePrice === 0 && totalFinalPrice === 0;

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex justify-between">
        <span className="text-xs text-slate-600">Total Base</span>
        <span className="text-xs font-semibold text-slate-700 tabular-nums">{money(totalBasePrice)}</span>
      </div>
      {totalDiscountAmount > 0 && (
        <div className="flex justify-between">
          <span className="text-xs text-slate-600">Total Potongan</span>
          <span className="text-xs font-semibold text-orange-600 tabular-nums">- {money(totalDiscountAmount)}</span>
        </div>
      )}
      <div className="flex justify-between">
        <span className="text-sm font-semibold text-slate-700">Total Final</span>
        <div className="flex flex-col items-end gap-0">
          <span className="text-sm font-bold text-brand-600 tabular-nums">{money(totalFinalPrice)}</span>
          {totalDiscountAmount > 0 && (
            <span className="text-[10px] text-orange-600 tabular-nums">({discountPercent.toFixed(2)}%)</span>
          )}
        </div>
      </div>
      {(isMissingPrice || hasPriceIssue) && (
        <p className="text-[10px] text-red-600">Warning: pricing perlu dicek (nilai kosong/negatif/terlalu ekstrem).</p>
      )}
    </div>
  );
};

export default PriceSummaryBlock;
